import React from "react";

const FinanceKpiCard = ({
  icon: Icon,
  iconBgClass = "bg-cfTemplateTransitionColor2 text-cfPrimary",
  value,
  label,
  subtitle,
  loading = false,
  dataTestId,
}) => {
  return (
    <div
      id={dataTestId}
      className="flex items-center gap-3.5 py-6 px-5 bg-white border border-gray-200 rounded-2xl shadow-xl transition-all duration-200 hover:shadow-md min-w-0"
    >
      <div
        className={`flex items-center justify-center w-12 h-12 rounded-full flex-shrink-0 ${iconBgClass}`}
      >
        {Icon ? <Icon className="w-6 h-6" aria-hidden="true" /> : null}
      </div>
      <div className="flex flex-col min-w-0">
        {loading ? (
          <div className="animate-pulse space-y-2">
            <div className="h-8 w-28 bg-gray-200 rounded-md" />
            <div className="h-4 w-24 bg-gray-200 rounded-md" />
            {subtitle ? (
              <div className="h-3 w-20 bg-gray-200 rounded-md" />
            ) : null}
          </div>
        ) : (
          <>
            <span className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight truncate">
              {value}
            </span>
            <span className="text-sm font-medium text-gray-600 mt-0.5">
              {label}
            </span>
            {subtitle ? (
              <span className="text-xs text-gray-400 mt-0.5">{subtitle}</span>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
};

export default FinanceKpiCard;
